import React from "react";
import {
  Target,
  Eye,
  Rocket,
  Building2,
  ShieldCheck,
  Award,
  Handshake,
  Cpu,
  Truck,
  Leaf,
  Headphones,
  Users,
  Flame,
  Scale,
  BadgeCheck,
  Microscope,
  Mail,
  Sparkles,
} from "lucide-react";

const Company = () => {
  return (
    <div className="bg-white overflow-hidden">
      {/* HERO */}
      <section className="relative min-h-[680px] lg:min-h-[760px] overflow-hidden bg-white">
        <div className="absolute inset-0">
          <div
            className="
        absolute
        inset-0
        bg-[radial-gradient(circle_at_75%_45%,rgba(238,125,50,0.10),transparent_32%),linear-gradient(110deg,#ffffff_0%,#ffffff_52%,#fafafa_100%)]
      "
          />
          <div
            className="
        absolute
        -right-[180px]
        -top-[180px]
        w-[650px]
        h-[650px]
        rounded-full
        border
        border-[#ee7d32]/10
        animate-[spin_30s_linear_infinite]
      "
          />

          <div
            className="
        absolute
        -right-[120px]
        -top-[120px]
        w-[530px]
        h-[530px]
        rounded-full
        border
        border-[#ee7d32]/10
      "
          />
          <div
            className="
        absolute
        right-[15%]
        top-[35%]
        w-[350px]
        h-[350px]
        rounded-full
        bg-[#ee7d32]/10
        blur-[110px]
      "
          />

          <div
            className="
        absolute
        left-[5%]
        top-[22%]
        grid
        grid-cols-4
        gap-3
        opacity-20
      "
          >
            {Array.from({ length: 16 }).map((_, i) => (
              <span
                key={i}
                className="
            w-[4px]
            h-[4px]
            rounded-full
            bg-[#ee7d32]
          "
              />
            ))}
          </div>
        </div>

        <div
          className="
      relative
      z-10
      max-w-[1500px]
      mx-auto
      min-h-[680px]
      lg:min-h-[760px]
      grid
      lg:grid-cols-[0.9fr_1.1fr]
      items-center
    "
        >
          <div
            className="
        relative
        px-6
        sm:px-10
        lg:pl-24
        xl:pl-32
        py-20
        lg:py-0
        z-20
      "
          >
            <div
              className="
          inline-flex
          items-center
          gap-3
          mb-7
          animate-[fadeInUp_0.7s_ease-out]
        "
            >
              <span
                className="
            w-10
            h-[3px]
            rounded-full
            bg-[#ee7d32]
          "
              />

              <span className="text-[#ee7d32] font-[800] text-[18px] tracking-wide">
                Nuestra compañía
              </span>
            </div>

            <h1
              className="
          text-[#111]
          font-[600]
          leading-[0.98]
          tracking-[-2.5px]
          text-[44px]
          sm:text-[58px]
          lg:text-[64px]
          xl:text-[72px]
          max-w-[700px]
        "
            >
              Construimos
              <br />
              <span className="relative inline-block">soluciones</span>
              <br />
              <span className="text-[#ee7d32]">que transforman</span>
            </h1>

            <p
              className="
          mt-8
          text-gray-500
          text-[15px]
          sm:text-[16px]
          leading-[1.9]
          max-w-[540px]
        "
            >
              Impulsamos soluciones sostenibles e innovadoras para el sector
              energético mediante tecnología, experiencia y excelencia
              operativa.
            </p>

            <div
              className="
          mt-9
          flex
          items-center
          gap-4
        "
            >
              <div
                className="
            w-[90px]
            h-[4px]
            rounded-full
            bg-[#ee7d32]
          "
              />

              <span
                className="
            text-[11px]
            font-bold
            uppercase
            tracking-[2px]
            text-gray-400
          "
              >
                Experiencia · Innovación · Sostenibilidad
              </span>
            </div>
          </div>

          <div
            className="
        relative
        h-full
        min-h-[500px]
        lg:min-h-[760px]
        flex
        items-center
        justify-center
        lg:justify-end
        pr-6
        sm:pr-10
        lg:pr-20
        xl:pr-28
        pb-16
        lg:pb-0
      "
          >
            <div
              className="
          absolute
          w-[430px]
          h-[430px]
          sm:w-[520px]
          sm:h-[520px]
          lg:w-[620px]
          lg:h-[620px]
          rounded-full
          border
          border-[#ee7d32]/10
          animate-[pulse_5s_ease-in-out_infinite]
        "
            />

            <div
              className="
          relative
          z-10
          w-[290px]
          sm:w-[360px]
          lg:w-[440px]
          xl:w-[500px]
          aspect-[0.82]
          rounded-[40px]
          overflow-hidden
          shadow-[0_35px_90px_rgba(0,0,0,0.15)]
          border
          border-white
          group
        "
            >
              <img
                src="/Images/company/company.webp"
                alt="Nuestra compañía"
                className="
            w-full
            h-full
            object-cover
            object-center
            transition-transform
            duration-[1800ms]
            ease-out
            group-hover:scale-[1.07]
          "
              />

              <div
                className="
            absolute
            inset-0
            bg-gradient-to-t
            from-black/35
            via-transparent
            to-transparent
          "
              />

              <div
                className="
            absolute
            left-6
            bottom-6
            right-6
          "
              >
                <p
                  className="
              text-white
              text-xl
              font-bold
            "
                >
                  Energía que transforma.
                </p>
              </div>
            </div>

            <div
              className="
          absolute
          z-20
          left-[2%]
          sm:left-[8%]
          lg:left-[4%]
          bottom-[8%]
          lg:bottom-[18%]
          bg-white
          rounded-2xl
          px-5
          py-4
          shadow-[0_20px_50px_rgba(0,0,0,0.12)]
          border
          border-gray-100
          animate-[float_5s_ease-in-out_infinite]
        "
            >
              <div className="flex items-center gap-3">
                <div
                  className="
              w-10
              h-10
              rounded-xl
              bg-[#fff3eb]
              flex
              items-center
              justify-center
            "
                >
                  <Sparkles
                    className="
                w-5
                h-5
                stroke-[#ee7d32]
              "
                  />
                </div>

                <div>
                  <p
                    className="
                text-[10px]
                uppercase
                tracking-[1.5px]
                font-bold
                text-gray-400
              "
                  >
                    Nuestro enfoque
                  </p>

                  <p
                    className="
                text-sm
                font-bold
                text-[#111]
              "
                  >
                    Innovación continua
                  </p>
                </div>
              </div>
            </div>

            <div
              className="
          absolute
          z-20
          right-[5%]
          top-[15%]
          w-14
          h-14
          rounded-2xl
          bg-white
          shadow-[0_15px_40px_rgba(0,0,0,0.10)]
          flex
          items-center
          justify-center
          animate-[float_10s_ease-in-out_infinite]
        "
            >
              <div
                className="
            w-3
            h-3
            rounded-full
            bg-[#ee7d32]
            animate-ping
          "
              />
            </div>
          </div>
        </div>
      </section>

      {/* SOBRE NOSOTROS */}
      <section className="relative py-24 bg-[#f5f5f5]  overflow-hidden">
        <div
          className="
      absolute
      top-[-120px]
      right-[-120px]
      w-[420px]
      h-[420px]
      rounded-full
      blur-3xl
    "
        />

        <div />

        <div
          className="
      max-w-[1400px]
      mx-auto
      px-6
      lg:px-12
      relative
      z-10
    "
        >
          <div
            className="
        grid
        lg:grid-cols-2
        gap-16
        items-center
      "
          >
            <div className="relative order-1 lg:order-2">
              <div className="flex items-center gap-5 mb-5">
                <span className="text-[#ee7d32] font-[800] text-[18px] tracking-wide">
                  SOBRE NOSOTROS
                </span>
              </div>

              <h2
                className="
            text-[#111]
            font-[900]
            leading-[1]
            tracking-[-2px]
            text-[44px]
            sm:text-[58px]
            lg:text-[68px]
            max-w-[700px]
          "
              >
                Quiénes Somos
              </h2>

              <div
                className="
            mt-10
            space-y-6
            text-gray-600
            text-[18px]
            leading-[2]
            max-w-[700px]
          "
              >
                <p>
                  Fundada en 2012,{" "}
              <strong className="font-bold text-[#111]">
  SIERRA ALTA SAS
</strong> es
                  una empresa colombiana especializada en soluciones integrales
                  para la industria energética e hidrocarburos, con experiencia
                  en Fluidos de Perforación, Fluidos de Completamiento, Control
                  de Sólidos y análisis ambiental acreditado por el IDEAM,
                  trabajando bajo altos estándares de calidad, innovación y
                  sostenibilidad.
                </p>
              </div>
            </div>

            <div className="relative order-2 lg:order-1">
              <div
                className="
            absolute
            -left-6
            top-10
            flex
            flex-col
            gap-4
            z-20
          "
              >
                {Array.from({ length: 6 }).map((_, i) => (
                  <div
                    key={i}
                    className="w-[8px] h-[8px] rounded-full bg-[#ee7d32]"
                  />
                ))}
              </div>

              <div className="relative max-w-[620px]">
                <div
                  className="
              absolute
              inset-0
              bg-gradient-to-br
              from-[#ee7d32]/20
              to-transparent
              rounded-[38px]
              translate-x-5
              translate-y-5
            "
                />

                <div
                  className="
              relative
              overflow-hidden
              rounded-[36px]
              shadow-[0_25px_70px_rgba(0,0,0,0.16)]
              h-[520px]
              border
              border-white/60
            "
                >
                  <img
                    src="/Images/company/about.webp"
                    alt="Sobre Nosotros"
                    className="
                w-full
                h-full
                object-cover
                hover:scale-105
                transition-all
                duration-[2000ms]
              "
                  />

                  <div
                    className="
                absolute
                inset-0
                bg-gradient-to-t
                from-black/20
                via-transparent
                to-transparent
              "
                  />
                </div>

                <div
                  className="
              absolute
              bottom-[-25px]
              right-[-25px]
              bg-[#ee7d32]
              text-white
              rounded-[28px]
              px-10
              py-8
              shadow-[0_20px_50px_rgba(243,112,33,0.35)]
              border
              border-white/20
              backdrop-blur-sm
            "
                >
                  <h3 className="text-[56px] text-white leading-none font-[900] tracking-[-2px]">
                    +10
                  </h3>

                  <p className="mt-2 text-[16px] font-[600] text-white/90">
                    Años de Experiencia
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MISIÓN Y VISIÓN */}
      <section className="relative py-24 bg-white overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 gap-16">
            {/* MISIÓN */}
            <div className="relative pl-8 border-l-4 border-[#ee7d32]">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full bg-[#fff3ec] flex items-center justify-center">
                  <Target size={34} stroke="#ee7d32" />
                </div>

                <div>
                  <span className="text-xs font-bold text-[#ee7d32] uppercase tracking-widest">
                    Propósito
                  </span>
                  <h3 className="text-[30px] font-extrabold text-[#111]">
                    Misión
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 leading-[1.9] text-[17px]">
                En <strong className="text-[#111]">SIERRA ALTA SAS</strong>{" "}
                aceptamos todos los retos en beneficio del sector energético, el
                país y la compañía, desarrollando y suministrando productos y
                servicios innovadores amigables con el medio ambiente, adaptados
                a las necesidades de nuestros clientes, proporcionando
                soluciones de ingeniería del más alto nivel y valor agregado.
              </p>
            </div>

            {/* VISIÓN */}
            <div className="relative pl-8 border-l-4 border-[#ee7d32]">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full bg-[#fff3ec] flex items-center justify-center">
                  <Eye size={34} stroke="#ee7d32" />
                </div>

                <div>
                  <span className="text-xs font-bold text-[#ee7d32] uppercase tracking-widest">
                    Proyección
                  </span>
                  <h3 className="text-[30px] font-extrabold text-[#111]">
                    Visión
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 leading-[1.9] text-[17px]">
                <strong className="text-[#111]">SIERRA ALTA SAS</strong> será
                reconocida por su posicionamiento diferenciado, al mantenernos
                ágiles en el desarrollo de soluciones integrales con un enfoque
                sostenible para el sector energético y ambiental.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* NUESTRA TRAYECTORIA */}
      <section className="relative py-24 bg-[#f5f5f5]  overflow-hidden">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16 relative">
            <div className="hidden sm:block absolute left-0 top-1/2 w-[120px] h-[2px] bg-[#ee7d32]"></div>
            <div className="hidden sm:block absolute right-0 top-1/2 w-[120px] h-[2px] bg-[#ee7d32]"></div>

            <h2 className="text-[44px] sm:text-[56px] font-[900] text-[#111] tracking-[-2px]">
              Nuestra Trayectoria
            </h2>

            <p className="text-gray-500 text-[18px] mt-4">
              Más de una década construyendo confianza y soluciones de valor
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 sm:left-1/2 sm:-translate-x-1/2 top-0 h-full w-[3px] bg-[#ee7d32]/40" />

            <div className="space-y-14">
              <div className="relative flex flex-col sm:flex-row">
                <div className="absolute left-2 sm:left-1/2 sm:-translate-x-1/2 w-14 h-14 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl">
                  <Rocket size={26} color="#fff" />
                </div>

                <div className="sm:w-1/2 sm:pr-12 pl-20 sm:pl-0 sm:text-right">
                  <span className="text-[#ee7d32] font-[800] text-[18px]">
                    2012
                  </span>
                  <h3 className="text-[22px] font-[800] text-[#111] mt-1">
                    Fundación de Sierra Alta SAS
                  </h3>
                  <p className="text-gray-600 mt-3 leading-[1.8] bg-[#fafafa] p-5 rounded-2xl border border-gray-100">
                    Tres ingenieros crean la empresa con experiencia en Oil &
                    Gas, Drilling & Completion, Química y Workover.
                  </p>
                </div>

                <div className="hidden sm:block sm:w-1/2"></div>
              </div>

              <div className="relative flex flex-col sm:flex-row">
                <div className="absolute left-2 sm:left-1/2 sm:-translate-x-1/2 w-14 h-14 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl">
                  <Building2 size={26} color="#fff" />
                </div>

                <div className="hidden sm:block sm:w-1/2"></div>

                <div className="sm:w-1/2 sm:pl-12 pl-20">
                  <span className="text-[#ee7d32] font-[800] text-[18px]">
                    2016
                  </span>
                  <h3 className="text-[22px] font-[800] text-[#111] mt-1">
                    Posicionamiento en el mercado
                  </h3>
                  <p className="text-gray-600 mt-3 leading-[1.8] bg-[#fafafa] p-5 rounded-2xl border border-gray-100">
                    La empresa se consolida gracias a la confianza en proyectos
                    de Drilling en campos de gas.
                  </p>
                </div>
              </div>

              <div className="relative flex flex-col sm:flex-row">
                <div className="absolute left-2 sm:left-1/2 sm:-translate-x-1/2 w-14 h-14 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl">
                  <ShieldCheck size={26} color="#fff" />
                </div>

                <div className="sm:w-1/2 sm:pr-12 pl-20 sm:pl-0 sm:text-right">
                  <span className="text-[#ee7d32] font-[800] text-[18px]">
                    2017
                  </span>
                  <h3 className="text-[22px] font-[800] text-[#111] mt-1">
                    Resiliencia en crisis petrolera
                  </h3>
                  <p className="text-gray-600 mt-3 leading-[1.8] bg-[#fafafa] p-5 rounded-2xl border border-gray-100">
                    Soporte técnico y asesoría especializada durante la crisis
                    del petróleo.
                  </p>
                </div>

                <div className="hidden sm:block sm:w-1/2"></div>
              </div>

              <div className="relative flex flex-col sm:flex-row">
                <div className="absolute left-2 sm:left-1/2 sm:-translate-x-1/2 w-14 h-14 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl">
                  <Award size={26} color="#fff" />
                </div>

                <div className="hidden sm:block sm:w-1/2"></div>

                <div className="sm:w-1/2 sm:pl-12 pl-20">
                  <span className="text-[#ee7d32] font-[800] text-[18px]">
                    2018 - 2019
                  </span>
                  <h3 className="text-[22px] font-[800] text-[#111] mt-1">
                    Expansión y certificaciones
                  </h3>
                  <p className="text-gray-600 mt-3 leading-[1.8] bg-[#fafafa] p-5 rounded-2xl border border-gray-100">
                    Servicios a PETROCOLOMBIA y certificaciones ISO 9001, ISO
                    14001 y OHSAS 18001.
                  </p>
                </div>
              </div>

              <div className="relative flex flex-col sm:flex-row">
                <div className="absolute left-2 sm:left-1/2 sm:-translate-x-1/2 w-14 h-14 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl">
                  <Handshake size={26} color="#fff" />
                </div>

                <div className="sm:w-1/2 sm:pr-12 pl-20 sm:pl-0 sm:text-right">
                  <span className="text-[#ee7d32] font-[800] text-[18px]">
                    2020 - 2024
                  </span>
                  <h3 className="text-[22px] font-[800] text-[#111] mt-1">
                    Alianzas estratégicas e IDEAM
                  </h3>
                  <p className="text-gray-600 mt-3 leading-[1.8] bg-[#fafafa] p-5 rounded-2xl border border-gray-100">
                    Alianza con Weatherford y acreditación del laboratorio bajo
                    ISO/IEC 17025.
                  </p>
                </div>

                <div className="hidden sm:block sm:w-1/2"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NUESTRA ORGANIZACION*/}
      <section className="relative py-24 bg-white overflow-hidden">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16 relative">
            <div className="hidden sm:block absolute left-0 top-1/2 w-[120px] h-[2px] bg-[#ee7d32]"></div>
            <div className="hidden sm:block absolute right-0 top-1/2 w-[120px] h-[2px] bg-[#ee7d32]"></div>

            <h2 className="text-[44px] sm:text-[56px] font-[900] text-[#111] tracking-[-2px]">
              Nuestra Organización
            </h2>

            <p className="text-gray-500 text-[18px] mt-4">
              Equipos multidisciplinarios impulsando innovación
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="group relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                <Cpu size={34} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Ingeniería y Tecnología
              </h3>

              <div className="w-12 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Diseñamos y desarrollamos soluciones innovadoras para el sector
                energético, integrando tecnología, eficiencia y precisión
                técnica en cada proyecto.
              </p>
            </div>

            <div className="group relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                <Truck size={34} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Operaciones y Logística
              </h3>

              <div className="w-12 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Coordinamos y ejecutamos operaciones de manera eficiente,
                optimizando recursos, tiempos y procesos en campo y oficina.
              </p>
            </div>

            <div className="group relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                <Leaf size={34} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Sostenibilidad y Medio Ambiente
              </h3>

              <div className="w-12 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Implementamos prácticas responsables que minimizan el impacto
                ambiental y promueven el desarrollo sostenible en cada
                operación.
              </p>
            </div>

            <div className="group relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                <Headphones size={34} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Servicios al Cliente
              </h3>

              <div className="w-12 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Brindamos atención personalizada y soporte técnico
                especializado, garantizando respuestas ágiles y soluciones
                efectivas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* VALORES CORPORATIVOS */}
      <section className="relative py-24 bg-[#f5f5f5] overflow-hidden">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-[44px] sm:text-[56px] font-[900] text-[#111]">
              Valores Corporativos
            </h2>
            <div className="w-24 h-[3px] bg-[#ee7d32] mx-auto mt-4 rounded-full"></div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-lg">
                <Scale size={26} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">Disciplina</h3>

              <div className="w-10 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                La excelencia es el estándar mínimo en todo lo que hacemos.
              </p>
            </div>

            <div className="relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-lg">
                <Users size={26} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">Liderazgo</h3>

              <div className="w-10 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Trabajo en equipo con autonomía para lograr resultados de alto
                impacto.
              </p>
            </div>

            <div className="relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-lg">
                <Flame size={26} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">Pasión</h3>

              <div className="w-10 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Superar constantemente las expectativas de nuestros clientes.
              </p>
            </div>

            <div className="relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-lg">
                <ShieldCheck size={26} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Compromiso HSE
              </h3>

              <div className="w-10 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Seguridad, salud y bienestar como prioridad en cada operación.
              </p>
            </div>

            <div className="relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-lg">
                <BadgeCheck size={26} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Ética e Integridad
              </h3>

              <div className="w-10 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Actuamos con transparencia, honestidad y responsabilidad.
              </p>
            </div>

            <div className="relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-lg">
                <Leaf size={26} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Responsabilidad
              </h3>

              <div className="w-10 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Compromiso social y ambiental con impacto positivo.
              </p>
            </div>

            <div className="relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-lg">
                <Microscope size={26} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Rigor Científico
              </h3>

              <div className="w-10 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Procesos con altos estándares de calidad y confiabilidad.
              </p>
            </div>

            <div className="relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(243,112,33,0.18)] transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-lg">
                <Eye size={26} color="#fff" />
              </div>

              <h3 className="text-[20px] font-[800] text-[#111]">
                Transparencia
              </h3>

              <div className="w-10 h-[3px] bg-[#ee7d32] mx-auto mt-3 mb-4 rounded-full"></div>

              <p className="text-gray-600 leading-[1.7]">
                Comunicación abierta basada en información veraz y confiable.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACTO CTA */}
      <section className="relative bg-white py-16 overflow-hidden">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] blur-3xl rounded-full" />

        <div className="relative z-10 max-w-[1100px] mx-auto px-6 lg:px-16">
          <div className="relative bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.10)] px-8 py-12 lg:py-14 flex flex-col lg:flex-row items-center justify-between gap-10 overflow-hidden">
            <div className="absolute left-0 top-0 w-1 h-full bg-gradient-to-b from-[#ee7d32] to-transparent" />

            <div className="flex items-center lg:items-start gap-6 text-center lg:text-left">
              <div className="flex items-center justify-center">
                <Mail
                  size={44}
                  className="stroke-[#ee7d32] drop-shadow-sm"
                  strokeWidth={2}
                />
              </div>

              <div>
                <h2 className="text-[28px] lg:text-[34px] font-[800] text-[#111] leading-tight">
                  Habla con un experto
                </h2>

                <p className="mt-3 text-gray-500 text-[15px] max-w-[520px] leading-relaxed">
                  Estamos prestos a escucharte, descubre cómo podemos ayudarte a
                  alcanzar tus objetivos energéticos y ambientales.
                </p>
              </div>
            </div>

            <a
              href="/contact-us"
              className="
          relative
          px-10 py-4
          bg-[#ee7d32]
          text-white
          font-semibold
          rounded-xl
          shadow-[0_10px_25px_rgba(243,112,33,0.35)]
          hover:shadow-[0_15px_35px_rgba(243,112,33,0.45)]
          hover:-translate-y-1
          transition-all
          whitespace-nowrap
          overflow-hidden
        "
            >
              <span className="absolute inset-0 bg-white/10 opacity-0 hover:opacity-100 transition" />
              Contáctanos
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Company;
